import { render, staticRenderFns } from "./ClubDiscountBanner.vue?vue&type=template&id=1bb89782&scoped=true&"
import script from "./ClubDiscountBanner.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClubDiscountBanner.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ClubDiscountBanner.vue?vue&type=style&index=0&id=1bb89782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb89782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb89782')) {
      api.createRecord('1bb89782', component.options)
    } else {
      api.reload('1bb89782', component.options)
    }
    module.hot.accept("./ClubDiscountBanner.vue?vue&type=template&id=1bb89782&scoped=true&", function () {
      api.rerender('1bb89782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/components/PaymentClub/components/ClubDiscountBanner.vue"
export default component.exports